﻿import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const WeeklyLoadTile = {
    fields: {
        label: { type: "text" as const },
        colorClass: { type: "text" as const },
    },
    defaultProps: {
        label: "Weekly Load (PSS)",
        colorClass: "from-orange-500 to-orange-600",
    },
    inline: true,
    render: (props: any) => {
        const { label, colorClass, puck } = props as any;
        const { weekReport } = useActivitiesData();
        const value = (weekReport?.weeklyLoad ?? 0).toFixed(0);
        return (
            <div ref={puck.dragRef} className={`bg-gradient-to-br ${colorClass} rounded-lg p-5 text-white`}>
                <div className="text-2xl font-bold">{value}</div>
                <div className="text-orange-100">{label}</div>
            </div>
        );
    },
};

export default WeeklyLoadTile;


